<template>
  <v-alert :color="color" transition="scale-transition" prominent>
    <v-row align="center">
      <v-col class="col-12">
        <p>
          You are about to pause the {{ dataSource }} tube. Are you sure you
          wish to proceed? Please note this operation may take awhile to
          complete and will continue in the background.
        </p>
        <p>
          <strong>Pausing means</strong>
        </p>
        <ul>
          <li>The tube will no longer be scheduled to sync.</li>
          <li>All jobs not yet started will be removed and lost.</li>
          <li>
            Jobs already processing will still resume and may spawn new jobs.
          </li>
          <li>
            New jobs added from backfills or other tubes will still be
            processed.
          </li>
          <li>
            New jobs added while this operation is still executing may
            potentially be lost.
          </li>
        </ul>
        <br />
        <p>
          <strong>After pausing you can</strong>
        </p>
        <ul>
          <li>Schedule the tube to resume the tube again.</li>
          <li>Start new backfills.</li>
        </ul>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col class="col-12">
        <v-btn
          class="col-12"
          large
          outlined
          :disabled="$store.state.pausing"
          :loading="$store.state.pausing"
          v-on:click="stop"
        >
          Pause {{ dataSource }}
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  props: {
    color: { type: String },
    client: { type: String, default: '' },
    dataSource: { type: String, default: '' },
  },
  methods: {
    stop() {
      this.$store.dispatch('pause', {
        client: this.client,
        dataSource: this.dataSource,
      });
    },
  },
  computed: {},
};
</script>
